import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DeliveryMethodGridComponent} from '../../components/delivery-method-grid/delivery-method-grid.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ConfirmService, HttpLoaderService, ListViewSelectionMode} from '@tymes4-shared';
import {PassePartoutValidator} from './passe-partout.validator';
import { LinkPricelistComponent } from '../../components/link-pricelist/link-pricelist.component';
import {TranslateService} from "@ngx-translate/core";
import {
  AllEventsForPassePartoutView,
  AllEventsForPassePartoutViewPagedResult,
  ETicketTemplate,
  ETicketTemplateService,
  HardcardTemplate,
  HardcardTemplateService,
  PassePartout,
  PassePartoutBarcodeProlongation,
  PassePartoutDeliveryMethodView,
  PassePartoutDetail,
  PassePartoutService,
  PassePartoutStoreArgs,
  PassePartoutType,
  PassePartoutTypeService,
  PaymentMethodModel,
  PurchaseRightService,
  Season,
  SeasonService,
  TenantShop,
  TenantShopService
} from '../../api';
import {ApplicationModuleHelperService, ApplicationModules} from '../../services/application-module.service';
import {AccountingDimensionHelperService} from '../../services/accounting-dimension.service';
import {forkJoin, Observable} from 'rxjs';

@Component({
    selector: 'app-edit-passe-partout-form',
    templateUrl: './edit-passe-partout-form.component.html',
    styleUrls: ['./edit-passe-partout-form.component.scss'],
    standalone: false
})
export class EditPassePartoutFormComponent implements OnInit {
  @ViewChild('deliveryMethodComponent') deliveryMethodComponent: DeliveryMethodGridComponent;
  @ViewChild('priceListComponent') linkPricelistComponent: LinkPricelistComponent;
  @ViewChild('pagerComponent') pagerComponent: any;


  currentTabId = 'details';

  public selectableHardcardTemplates: Array<HardcardTemplate> = [];
  public eTicketTemplates = [];
  private isNew: boolean = false;
  private passePartout: any = {};
  public form: FormGroup;
  public keepBarcode: boolean = false;

  public pagedPptEvents: any = [];
  public passePartoutEvents: Array<AllEventsForPassePartoutView> = [];

  public saving: boolean = false;
  public passePartoutId: number;
  public paymentmethods: Array<PaymentMethodModel> = null;
  public tenantShopList: TenantShop[] = [];
  public paymentMethodActiveTenantShop: TenantShop;

  public passePartoutTypes: Array<PassePartoutType> = [];
  public precedingPassePartouts: Array<PassePartout> = [];
  public seasons: Array<Season> = [];
  public deliveryMethodData: Array<PassePartoutDeliveryMethodView> = [];
  selectablePrecedingPassePartouts: Array<PassePartout> = [];
  public showMobileTicketSection = false;
  public showMarketplaceSection = false;
  public PassePartoutBarcodeProlongations: Array<number> = [];
  public prolongingOptions: Array<PassePartoutBarcodeProlongation> = [];

  public showDim1: boolean = false;
  public showDim2: boolean = false;
  public showDim3: boolean = false;
  public showDim4: boolean = false;
  public showDim5: boolean = false;

  validationMessages = {
    'Named': [
      {type: 'namedNotCorrect', message: 'FORM.VALIDATION.NAMEDNOTCORRECT'}
    ]
  }

  @ViewChild('paymentListVw') channelListVw;


  public paymentMethodsListOptions = {
    search: false,
    pageSize: 12,
    disableSort: true,
    renderInCard: false,
    noItemsText: this.translate.instant('GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND'),
    searchTitle: this.translate.instant('MANAGEMENT.MULTI-EVENT.EDITDIALOG.SEARCH.TITLE'),
    selectionMode: ListViewSelectionMode.None,
    headers: [
      {sortField: null, label: '', width: 50, hideOn: null},
      {
        sortField: null,
        label: this.translate.instant('MANAGEMENT.MULTI-EVENT.EDITDIALOG.HEADER.LISTVW.NAME'),
        width: null,
        hideOn: null
      },
    ]
  };

  selectablePassePartoutTypes: Array<PassePartoutType> = [];

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              public dialogRef: MatDialogRef<EditPassePartoutFormComponent>,
              private passePartoutService: PassePartoutService,
              private passePartoutValidator: PassePartoutValidator,
              private confirmService: ConfirmService,
              private loader: HttpLoaderService,
              private purchaseRightService: PurchaseRightService,
              private passePartoutTypeService: PassePartoutTypeService,
              private hardcardTemplateService: HardcardTemplateService,
              private translate: TranslateService,
              private seasonService: SeasonService,
              private eTicketTemplateService: ETicketTemplateService,
              private applicationModuleHelperService: ApplicationModuleHelperService,
              private accountingDimensionHelperService: AccountingDimensionHelperService,
              private tenantShopService: TenantShopService,
              private router: Router) {
  }

  ngOnInit() {
    this.applicationModuleHelperService.getActiveModules().subscribe((module) => {
      this.showMarketplaceSection = (module && module.includes(ApplicationModules.SecondaryTicketing));
      this.showMobileTicketSection = (module && module.includes(ApplicationModules.MobileTicketing));
    });

    this.tenantShopService.listAllTenantShops().subscribe(result => {
      this.tenantShopList = result;
      this.paymentMethodActiveTenantShop = this.tenantShopList[0];
    });

    this.accountingDimensionHelperService.getActiveAccountingDimensions().subscribe((activeDimensions) => {
      this.showDim1 = (activeDimensions && activeDimensions.includes('accountingdimension1'));
      this.showDim2 = (activeDimensions && activeDimensions.includes('accountingdimension2'));
      this.showDim3 = (activeDimensions && activeDimensions.includes('accountingdimension3'));
      this.showDim4 = (activeDimensions && activeDimensions.includes('accountingdimension4'));
      this.showDim5 = (activeDimensions && activeDimensions.includes('accountingdimension5'));
    })

    this.isNew = this.passedData.isNew;
    this.passePartout = this.passedData.passepartout;


    this.form = new FormGroup({
      Id: new FormControl(0),
      Name: new FormControl('', [Validators.required]),
      Code: new FormControl('', {
        validators: Validators.required,
        asyncValidators: [this.passePartoutValidator.passePartoutCodeTaken.bind(this)],
        updateOn: "blur"
      }),
      IdentificationRequired: new FormControl(false),
      IdentificationRequiredUponPurchase: new FormControl(false),
      PassePartoutTypeId: new FormControl(null, [Validators.required]),
      Active: new FormControl(true),
      ExtraInfo: new FormControl(''),
      Named: new FormControl(false),
      IsUniquelyAssigned: new FormControl(false),
      PhotoRequired: new FormControl(false),
      HasSoldOut: new FormControl(false),
      ApplyIndexing: new FormControl(true),
      PrecedingPassePartoutId: new FormControl(null),
      KeepPrecedingBarcode: new FormControl(false),
      SeasonId: new FormControl('', Validators.required),
      AccountingExternalCode: new FormControl(''),
      HardcardTemplateId: new FormControl(-1),
      MobileTicketFrontTemplateId: new FormControl(-1),
      MobileTicketBackTemplateId: new FormControl(-1),
      MaxResell: new FormControl(0),
      MaxSeasonCardAmount: new FormControl(0),
      MaxSwap: new FormControl(0),
      LimitResell: new FormControl(false),
      AdditionalAttribute: new FormControl(''),
      AccountingDimensionCode1: new FormControl(''),
      AccountingDimensionCode2: new FormControl(''),
      AccountingDimensionCode3: new FormControl(''),
      AccountingDimensionCode4: new FormControl(''),
      AccountingDimensionCode5: new FormControl(''),
      ShowMobileTicketInTicketshop: new FormControl(false),
      DistributeMobileTicketInTicketshop: new FormControl(false),
      LinkToApp: new FormControl(false),
      ShowInExternal: new FormControl(false),
      LimitSeasonCardAmount: new FormControl(false),
      PassePartoutBarcodeProlongations: new FormControl(null),
      IsParkingOnly: new FormControl(false)
    });

    if (this.passePartout === void 0) this.passePartout = {};
    this.passePartoutId = this.passePartout.Id;

    this.passePartoutValidator.editingObject = this.passePartout;

    if (!this.isNew) {

      this.passePartoutService.getPassePartoutDetail(this.passePartout.Id).subscribe((pptDetails: PassePartoutDetail) => {
        let additionalFilters: { [key: string]: string; } = {};
        additionalFilters['passePartoutId'] = this.passePartout.Id.toString();

        this.passePartoutService.searchForPassePartoutEvents('', 1, 99999999, 'Name', true, additionalFilters).subscribe((data: AllEventsForPassePartoutViewPagedResult) => {
          this.passePartoutEvents = data.Records;
          this.setPage(1);
        });

        //close this dialog and pass the newly added id to the called
        if (pptDetails.HardcardTemplateId === null) pptDetails.HardcardTemplateId = -1;
        if (pptDetails.MobileTicketFrontTemplateId === null) pptDetails.MobileTicketFrontTemplateId = -1;
        if (pptDetails.MobileTicketBackTemplateId === null) pptDetails.MobileTicketBackTemplateId = -1;
        this.passePartout = pptDetails;

        this.form.patchValue(this.passePartout);
        this.keepBarcode = this.passePartout.KeepPrecedingBarcode;
        this.enablePassePartoutBarcodeProlongations();

        this.onLimitResellChange();
        this.onLimitSeasonCardAmountChange();
        this.onPassePartoutTypeChange();
      });

      this.passePartoutService.getPassePartoutDeliveryMethods(this.passePartoutId).subscribe((deliveryMethods: Array<PassePartoutDeliveryMethodView>) => {
        this.deliveryMethodData = deliveryMethods;
        this.deliveryMethodComponent.data = deliveryMethods;
        this.deliveryMethodComponent.initialize();
      });
    }

    this.passePartoutTypeService.getAllPassePartoutTypes().subscribe((data: Array<PassePartoutType>) => {
      this.passePartoutTypes = data;
      this.selectablePassePartoutTypes = this.passePartoutTypes;

      this.onPassePartoutTypeChange();
    });

    this.loadHardcardTemplates();
    this.loadSeasons();

    let calls: Observable<any>[] = [];
    calls.push(this.passePartoutService.getPastPassePartouts());
    if (this.passePartoutId != null) {
      calls.push(this.passePartoutService.getPrecedingPassePartoutIds(this.passePartoutId));
      calls.push(this.passePartoutService.getPassePartoutBarcodeProlongations(this.passePartoutId));
    }

    forkJoin(calls).subscribe(([data, precedingIds, prolongingOptions]: [Array<PassePartout>, Array<number>, Array<PassePartoutBarcodeProlongation>]) => {
      this.precedingPassePartouts = data;
      this.selectablePrecedingPassePartouts = this.precedingPassePartouts;
      if (this.passePartoutId != null) {
        this.prolongingOptions = prolongingOptions.map(option => {
          return {
            Id: option.Id,
            Created: option.Created,
            Modified: option.Modified,
            Name: data.find(item => item.Id == option.ProlongingPassePartoutId).Name,
            ProlongingPassePartoutId: option.ProlongingPassePartoutId,
            PrecedingPassePartoutId: option.PrecedingPassePartoutId
          }
        });
        this.form.controls.PassePartoutBarcodeProlongations.patchValue(precedingIds);
      }
    });

    this.onLimitResellChange();
    this.onLimitSeasonCardAmountChange();
  }

  updateKeepBarcode(keepBarcode) {
    this.keepBarcode = keepBarcode.target.checked;
    this.enablePassePartoutBarcodeProlongations();
  }

  enablePassePartoutBarcodeProlongations() {
    if (this.keepBarcode) {
      this.form.get("PassePartoutBarcodeProlongations").enable();
    } else {
      this.form.get("PassePartoutBarcodeProlongations").disable();
    }
  }

  loadHardcardTemplates() {
    this.hardcardTemplateService.listSelectableHardcardTemplates().subscribe((data: Array<HardcardTemplate>) => {
      this.selectableHardcardTemplates = data;
      //add the empty option
      this.selectableHardcardTemplates.splice(0, 0, {Name: this.translate.instant('GENERIC.DROPDOWN.NONE'), Id: -1});

    });

    this.eTicketTemplateService.listETicketTemplatesByType(2).subscribe((data: ETicketTemplate[]) => {
      this.eTicketTemplates = data;
      this.eTicketTemplates.unshift({Name: '[Geen]', Id: -1});
    });
  }

  updatePaymentmethod(paymentMethod, isChecked) {
    paymentMethod.HasPaymentMethod = isChecked;
  }

  onTabChange(e) {
    this.currentTabId = e.selectedTab.id;
  }


  doPageEvents(pageArgs) {
    this.setPage(pageArgs.pageNr);
  }

  setPage(pageNr: number) {
    this.pagedPptEvents = this.passePartoutEvents;
    let length = this.passePartoutEvents.length; //we need a copy
    this.pagerComponent.setObjectCount(length);

    this.pagedPptEvents = this.pagedPptEvents.slice((pageNr - 1) * this.pagerComponent.pageSize, (pageNr) * this.pagerComponent.pageSize);
    this.pagerComponent.setPage(pageNr);
  }


  onDataRequest(event) {
    if (this.paymentmethods !== null) {
      this.updateShownPaymentMethods();
      return;
    }

    const method = this.isNew
      ? this.passePartoutService.getNewPassePartoutPaymentMethods()
      : this.passePartoutService.getPassePartoutPaymentMethods(this.passePartout.Id);

    method.subscribe((data: Array<PaymentMethodModel>) => {
      this.setNewPaymentMethods(data);
      this.updateShownPaymentMethods();
    });
  }

  setPaymentMethodActiveShop(tenantShopId: number) {
    this.paymentMethodActiveTenantShop = this.tenantShopList.find(x => x.Id == tenantShopId);
    this.channelListVw.refreshData();
  }

  setNewPaymentMethods(data) {
    this.paymentmethods = [];
    this.tenantShopList.forEach(tenantShop => {
      const clonedData = JSON.parse(JSON.stringify(data));
      const uniquePayments = clonedData.filter((value, index, self) =>
        self.findIndex(v => v.Id === value.Id) === index
      );

      uniquePayments.forEach(item => {
        if (clonedData.find(x => x.Id == item.Id && x.TenantShopId == tenantShop.Id)) {
          this.paymentmethods.push(clonedData.find(x => x.Id == item.Id && x.TenantShopId == tenantShop.Id))
        } else {
          item.TenantShopId = tenantShop.Id;
          item.PaymentMethodExclusionId = null;
          item.HasPaymentMethod = true;
          this.paymentmethods.push(item)
        }
      });
    });
  }

  updateShownPaymentMethods() {
    let shownPaymentmethods = this.paymentmethods.filter(pm => pm.TenantShopId == this.paymentMethodActiveTenantShop.Id);
    this.channelListVw.Data = {
      TotalRecords: shownPaymentmethods.length,
      Records: shownPaymentmethods
    };
  }


  selectableSeasons: Array<Season> = null;

  loadSeasons() {
    if (!this.isNew) {
      this.seasonService.getAllSeasons().subscribe((data: Array<Season>) => {
        this.seasons = data;
        this.selectableSeasons = this.seasons;
      });

      return;
    }

    this.seasonService.getCurrentAndFutureSeasons().subscribe((data: Array<Season>) => {

      this.seasons = data;
      this.selectableSeasons = this.seasons;

      if (this.seasons.length > 0) {
        // default is current season (first from the list)
        this.form.controls.SeasonId.setValue(this.seasons[0].Id);
      }
    });
  }

  onNamedChange(checked: boolean) {
    if (checked !== false) {
      if (this.form.controls.Named.hasError('namedNotCorrect')) {
        this.form.controls.Named.setErrors(null);
        this.form.controls.Named.markAsTouched();
      }

      return;
    }

    if (!this.passePartoutId) {
      return;
    }

    this.purchaseRightService.checkNonTransferablePassePartout(this.passePartoutId).subscribe((data: boolean) => {
      if (data !== null && data !== void 0 && data) {
        this.form.controls.Named.setErrors({namedNotCorrect: true});
        this.form.controls.Named.markAsTouched();

        return;
      }

      if (this.form.controls.Named.hasError('namedNotCorrect')) {
        this.form.controls.Named.setErrors(null);
        this.form.controls.Named.markAsTouched();
      }
    });
  }

  onLimitResellChange() {
    if (this.form.value.LimitResell) {
      this.form.controls.MaxResell.enable();
      this.form.controls.MaxResell.setValidators([Validators.min(1)]);
    } else {
      this.form.controls.MaxResell.disable();
      this.form.controls.MaxResell.clearValidators();
    }

    this.form.controls.MaxResell.updateValueAndValidity();
  }

  onLimitSeasonCardAmountChange() {
    if (this.form.value.LimitSeasonCardAmount) {
      this.form.controls.MaxSeasonCardAmount.enable();
      this.form.controls.MaxSeasonCardAmount.setValidators([Validators.min(1)]);
    } else {
      this.form.controls.MaxSeasonCardAmount.disable();
      this.form.controls.MaxSeasonCardAmount.clearValidators();
    }

    this.form.controls.MaxResell.updateValueAndValidity();
  }

  onPassePartoutTypeChange() {
    const pptTypeId = this.form.value.PassePartoutTypeId
    const sccPptType = this.passePartoutTypes.find(pptt => pptt.Code == "SEIZ");
    if (pptTypeId === null || pptTypeId === undefined
      || sccPptType === null || sccPptType === undefined) {
      return;
    }

    if (sccPptType.Id === pptTypeId) {
      this.form.controls.MobileTicketFrontTemplateId.enable();
      this.form.controls.MobileTicketBackTemplateId.enable();
      this.form.controls.ShowMobileTicketInTicketshop.enable();
      this.form.controls.DistributeMobileTicketInTicketshop.enable();
      this.form.controls.LinkToApp.enable();
      this.form.controls.ShowInExternal.enable();

      return;
    }

    this.form.controls.MobileTicketFrontTemplateId.setValue(-1);
    this.form.controls.MobileTicketBackTemplateId.setValue(-1);
    this.form.controls.ShowMobileTicketInTicketshop.setValue(false);
    this.form.controls.DistributeMobileTicketInTicketshop.setValue(false);
    this.form.controls.LinkToApp.setValue(false);
    this.form.controls.ShowInExternal.setValue(false);

    this.form.controls.MobileTicketFrontTemplateId.disable();
    this.form.controls.MobileTicketBackTemplateId.disable();
    this.form.controls.ShowMobileTicketInTicketshop.disable();
    this.form.controls.DistributeMobileTicketInTicketshop.disable();
    this.form.controls.LinkToApp.disable();
    this.form.controls.ShowInExternal.disable();
  }

  submit() {
    const ppt = this.form.value;
    this.storePassePartout(ppt);
  }

  cleanDeliveryMethodDataForRequest(data) {
    const cleaned = [];
    for (const d of data) {
      cleaned.push({
        Id: d.PassePartoutDeliveryMethodId,
        DeliveryMethodId: d.DeliveryMethodId,
        PassePartoutId: d.PassePartoutId,
        VenueBuildingBlockId: d.VenueBuildingBlockId,
        Enabled: d.Enabled
      });
    }
    return cleaned;
  }

  storePassePartout(ppt) {
    this.loader.open();

    const hasPaymentMethodsSelected = (this.paymentmethods.map((p) => p.HasPaymentMethod).length > 0);
    if (!hasPaymentMethodsSelected) {
      this.loader.close();
      this.confirmService.confirm({
        title: this.translate.instant('MANAGEMENT.MULTI-EVENT.EDITDIALOG.SAVE.ERROR-NOT-POSSIBLE'),
        message: this.translate.instant('MANAGEMENT.MULTI-EVENT.EDITDIALOG.SAVE.MESSAGE.ERROR-NOT-POSSIBLE'),
        okonly: true
      }).subscribe();

      return;
    }

    if (+ppt.HardcardTemplateId == -1) ppt.HardcardTemplateId = null;

    const accountingDimension = {
      Code1: ppt.AccountingDimensionCode1,
      Code2: ppt.AccountingDimensionCode2,
      Code3: ppt.AccountingDimensionCode3,
      Code4: ppt.AccountingDimensionCode4,
      Code5: ppt.AccountingDimensionCode5
    }

    const args: PassePartoutStoreArgs = {
      LinkedPriceLists: this.linkPricelistComponent.linkedLists,
      PassePartout: ppt,
      PaymentMethods: this.paymentmethods,
      DeliveryMethods: this.cleanDeliveryMethodDataForRequest(this.deliveryMethodData),
      AccountingDimension: accountingDimension,
      PassePartoutBarcodeProlongations: this.form.controls.PassePartoutBarcodeProlongations.value
    };

    if (this.isNew) {
      this.passePartoutService.createPassepartout(args).subscribe((data: number) => {
        this.loader.close();
        this.dialogRef.close(true);
      });

      return;
    }

    args.DeliveryMethods = this.cleanDeliveryMethodDataForRequest(this.deliveryMethodData);

    this.passePartoutService.updatePassepartout(args).subscribe(data => {
      this.loader.close();
      this.dialogRef.close(true);
    });
  }

  navigateToEvent(eventId: number) {
    this.router.navigate(['/administration/sales/events/details', eventId]);
    this.dialogRef.close();
  }


}
